<ng-template #customModalTemplate>
  <div class="modal-content admin-modaldialog modal-basic" [ngClass]="dynamicClass">
    <div class="modal-header d-flex justify-content-between pt-0" *ngIf="headerLabel">
      <div class="modal-header-title">
        <h4 class="modal-title">
          {{ headerLabel }}
          <app-info-icon *ngIf="headerInfoMessage" [message]="headerInfoMessage"></app-info-icon>
        </h4>
        <div *ngIf="subHeader" class="sub-header">
          {{ subHeader }}
        </div>
      </div>
      <div *ngIf="showButtonOnHeader.showButton" class="pad-t-15">
        <app-button [btnField]="showButtonOnHeader" (handleButtonClick)="showButtonOnHeader.buttonClick()"></app-button>
      </div>
      <div class="pt-3 cursor-pointer" *ngIf="showCrossBtn && !(sideLogo || sideIconClass)"
        (click)="cancel(showBackBtn ? false : isSuccess)">
        <em class="icon-liteicon-close"></em>
      </div>
      <div *ngIf="sideLogo" class="mt-auto side-logo">
        <img appDisableRightClick appMobileOptimization [originalUrl]="sideLogo" [src]="sideLogo" [format]="'webp'" alt="logo" loading="lazy" decoding="async" />
      </div>
      <div *ngIf="sideIconClass" class="mt-auto side-icon">
        <em [ngClass]="sideIconClass"></em>
      </div>
      <div *ngIf="sideInfoMessage" class="mt-15px">
        <app-info-icon [message]="sideInfoMessage"></app-info-icon>
      </div>
    </div>
    <hr class="modal-break-line" *ngIf="headerLabel && showModalBreak" />
    <div class="modal-body">
      <div *ngIf="restrictedContentImagerc?.length > 0" class="restricted-content-image-container">
        <p-carousel
          [value]="restrictedContentImagerc"
          [numVisible]="1"
          [numScroll]="1"
          [circular]="false"
          [autoplayInterval]="0"
          [showNavigators]="restrictedContentImagerc?.length > 1 ? true : false"
          [showIndicators]="false"
          styleClass="custom-carousel"
          (onPage)="onCarouselPageChange($event)"
        >
          <ng-template let-imageData pTemplate="item">
            <div class="carousel-item-wrapper">
              <img
                appDisableRightClick
                appMobileOptimization
                [originalUrl]="imageData?.image"
                [src]="imageData?.image"
                [format]="'webp'"
                alt="Restricted"
                class="uploaded-image mb-3"
                loading="lazy"
                decoding="async"
              />
              <p class="reason">Reason: {{ imageData?.awsReason }}</p>
            </div>
          </ng-template>
        </p-carousel>
        <p class="image-counter" *ngIf="restrictedContentImagerc?.length>1">
          Restricted Image {{ currentCarouselIndex + 1 }} of {{ restrictedContentImagerc.length }}
        </p>        
      </div>      
      <div class="cursor-pointer cross-body-item" *ngIf="showCrossBtnInBody" (click)="cancel()">
        <em class="icon-liteicon-close"></em>
      </div>
      <p *ngIf="bodyContent" class="mt-0" [innerHTML]="bodyContent"></p>
      <ng-content></ng-content>
    </div>
    <div class="modal-footer" *ngIf="showConfirmationBtn" [ngClass]="{ 'delete-content-action': isDeleteModal }">
      <app-button *ngIf="tertiaryBtnLabel" (handleButtonClick)="tertiaryBtnEvent.emit()" [btnField]="{
          type: 'button',
          class: 'btn btn-default',
          label: tertiaryBtnLabel
        }"></app-button>
      <app-button *ngIf="secondaryBtnLabel" (handleButtonClick)="secondaryBtnClicked()" [btnField]="{
          type: 'button',
          class: cancelButtonClass,
          label: secondaryBtnLabel
        }"></app-button>

      <app-button *ngIf="secondaryCancelBtnLabel" (handleButtonClick)="cancel(showBackBtn ? true : false)" [btnField]="{
          type: 'button',
          class: isDeleteModal ? confirmButtonClass : cancelButtonClass,
          label: secondaryCancelBtnLabel
        }" [ngStyle]="isDeleteModal ? { order: 1 } : {}"></app-button>

      <app-button *ngIf="notShowConfirmBtn" (handleButtonClick)="confirm()" [btnField]="{
          type: 'button',
          class: isDeleteModal
            ? cancelButtonClass + ' default-btn-width'
            : confirmButtonClass,
          label: confirmBtnLabel,
          disabled: disableConfirmButton,
          loading: confirmBtnLoading,
          prefixIconPath: confirmBtnPrefixIconPath
        }" [ngStyle]="!isDeleteModal ? { order: 1 } : {}"></app-button>

      <app-button *ngIf="cancelBtnLabel" (handleButtonClick)="cancel(showBackBtn ? true : false)" [btnField]="{
          type: 'button',
          class: isDeleteModal ? confirmButtonClass : cancelButtonClass,
          label: cancelBtnLabel
        }" 
        [ngStyle]="(isDeleteModal ? confirmButtonClass : cancelButtonClass).includes('btn-primary') ? { order: 1 } : { order: 0 }"
        >
      </app-button>

    </div>
  </div>
</ng-template>